import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=2b661af1&scoped=true"
import script from "./ApplicationFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApplicationFooter.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b661af1",
  null
  
)

export default component.exports